import QUESTION_TYPE from "enums/QUESTION_TYPE";
import { keyScripts, useStore } from "hooks/useStore";
import QuestionDto from "types/QuestionDto";
import ScriptDto from "types/ScriptDto";
import { moveArrayIndex } from "utils/array";

interface StoreValues {
  setValue: (key: string, value: unknown) => void;
  addQuestion: (question: QuestionDto) => void;
  deleteQuestion: (index: number) => void;
  deleteAnswer: (questionIndex: number, answerIndex: number) => void;
  updateQuestion: (question: QuestionDto, index: number) => void;
  handleReset: () => void;
  script: ScriptDto;
  editIndex: number;
  isEditing: boolean;
  hasScriptChange: boolean;
  setHasScriptChange: (hasScriptChange: boolean) => void;
  hasScriptError: boolean;
  setHasScriptError: (hasScriptError: boolean) => void;
}

export default function useScriptManagementStore() {
  const {
    setHasScriptChange,
    setHasScriptError,
    hasScriptChange,
    hasScriptError,
    setValue,
    addQuestion,
    deleteQuestion,
    updateQuestion,
    script,
    handleReset,
    editIndex,
    isEditing,
  } = useStore((store) => store[keyScripts]) as StoreValues;

  const handleStoreChange = (key: keyof StoreValues, value: unknown) => {
    setValue(key, value);
  };

  const handleUpdateQuestion = (question, index) => {
    updateQuestion(question, index);
    setHasScriptChange(true);
  };

  const handleAddQuestion = () => {
    addQuestion({
      title: "",
      type: QUESTION_TYPE.VIDEO,
    });
  };

  const handleUpdateScript = (key: string, value: unknown) => {
    setValue("script", { ...script, [key]: value });
    setHasScriptChange(true);
  };

  const handleDeleteQuestion = (index: number) => {
    setValue("editIndex", -1);
    deleteQuestion(index);
    setHasScriptChange(true);
  };

  const handleQuestionDrop = (payload) => {
    const { index, hoverIndex } = payload;
    moveArrayIndex(script.questions, index, hoverIndex || 0);
    setValue("script", {
      ...script,
      questions: moveArrayIndex(script.questions, index, hoverIndex || 0),
    });
    setHasScriptChange(true);
  };

  return {
    isEditing,
    editIndex,
    hasScriptChange,
    hasScriptError,
    handleQuestionDrop,
    handleUpdateQuestion,
    handleUpdateScript,
    handleDeleteQuestion,
    handleAddQuestion,
    handleStoreChange,
    handleFormReset: handleReset,
    script,
    setHasScriptChange,
    setHasScriptError,
  };
}
